import { convertDate } from "../utils/dateTimeUtils";
import { compareTwoValues } from "../utils/main";

export const emptyPatientContext: PatientContextType = {
  id: undefined,
  age: 0,
  attributes: [],
  attributesUpdated: false,
  procedureDate: "0001-01-01",
  forceTableUpdate: 0,
  highlightedAttributesCount: 0,
};

export function patientActivityLogs(logs: ActivityLog[]) {
  const { stringToDate } = convertDate;
  return logs.map((log) => {
    return {
      ...log,
      createdAt: stringToDate(log.createdAt),
    };
  });
}

export function sortEncounterCodes(
  sort: string,
  sortBy: "code" | "description" | "visitDiffDays" | "codeDiffDays",
  codes: CodeBase[],
) {
  const dataSortedAsc = codes.sort((a, b) => {
    return compareTwoValues(a[sortBy], b[sortBy]);
  });
  if (sort === "asc") {
    return dataSortedAsc;
  }
  return dataSortedAsc.reverse();
}
